export default "__VITE_ASSET__fa640a1c__"